var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoll = function SvgPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 40 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.355 1.178a1.178 1.178 0 1 0-2.355 0v47.458a1.178 1.178 0 1 0 2.355 0v-6.065h20.218v-.002c1 0 1.811-.81 1.811-1.81v-5.166c0-1-.81-1.81-1.811-1.81H2.355V29.3h35.508c1.18 0 2.137-.957 2.137-2.137V22.65c0-1.18-.957-2.138-2.137-2.138H2.355v-4.48h7.707c.83 0 1.502-.673 1.502-1.503V8.746c0-.83-.672-1.503-1.502-1.503H2.355z",
    clipRule: "evenodd"
  })));
};
export default SvgPoll;